// Dropdown select component

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cn } from "@/lib/utils";

interface DropdownSelectProps {
  options: { label: string; value: string }[];
  placeholder: string;
  onChange: (_value: string) => void;
  error?: string;
  disabled?: boolean;
  currentLanguage?: string;
  value?: any;
  dropdownPosition?: "top" | "right" | "bottom" | "left";
}

export const DropdownSelect = ({
  options,
  placeholder,
  onChange,
  error,
  disabled,
  currentLanguage,
  value,
  dropdownPosition = "bottom",
}: DropdownSelectProps) => (
  <div>
    <Select
      disabled={disabled}
      onValueChange={onChange}
      value={value}
    >
      <SelectTrigger className={cn(currentLanguage === "en" ? "w-42.5" : "w-52.5", error && "border-red-500 border-2")}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent side={dropdownPosition}>
        {options.map((option, index) => (
          <SelectItem key={index} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
    {error && (
      <p className="input-error-message text-xs font-semibold pt-1">
        {error}
      </p>
    )}
  </div>
);
